import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog44/image1 20wma arrival where now_.png";
import image2 from "../../../../assets/images/Blog44/image2 big Treasury equals equity selling short term.png";
import image15 from "../../../../assets/images/Blog44/image15 GS AI circularity.png";
import image6 from "../../../../assets/images/Blog44/image6.png";
import image8 from "../../../../assets/images/Blog44/image8 GDPNow vs UoM collapse.png";
import image9 from "../../../../assets/images/Blog44/image9 China MS the top.png";
import image52 from "../../../../assets/images/Blog44/image52 UJ intervention coming soon.png";
import image11 from "../../../../assets/images/Blog44/image11 rate odds surge.png";
import image13 from "../../../../assets/images/Blog44/image13 VIX and MOVE.png";
import image14 from "../../../../assets/images/Blog44/image14 1D Vix.png";
import image19 from "../../../../assets/images/Blog44/image19 credit only worried about Oracle so far.png";
import image21 from "../../../../assets/images/Blog44/image21 Blue Owl credit withdrawn.png";
import image29 from "../../../../assets/images/Blog44/image29 Healthcare wins again.png";
import image34 from "../../../../assets/images/Blog44/image34 BOA sentiment flows.png";
import image32 from "../../../../assets/images/Blog44/image32 momentum fell off a cliff.png";
import image58 from "../../../../assets/images/Blog44/image58 BTC sentiment.png";
import image16 from "../../../../assets/images/Blog44/image16 hyperscalers angst.png";
import image53 from "../../../../assets/images/Blog44/image53 commodities still cheap.png";
import image54 from "../../../../assets/images/Blog44/image54 where are the gold bugs_ (1).png";
import image61 from "../../../../assets/images/Blog44/image61 BTC sharpe ratios.png";
import image88 from "../../../../assets/images/Blog44/image88 btc slump leads stocks lower.png";
import image42 from "../../../../assets/images/Blog44/image42 what a difference a day makes.png";
import image60 from "../../../../assets/images/Blog44/image60 BTC adption curve still positive.png";
const Blog44 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – November 24th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Liquidity Cracks, Narrow Breadth, and the Market Stuck in Transition</p>
        <p>
          Markets spent the week wrestling with a confusing mix of seasonality, liquidity stress, and fragile sentiment. What should have been a clean fourth-wave reset has turned into a deeper
          psychological shakeout, with even committed dip buyers beginning to question the playbook. The backdrop remains messy: repo-market tightness, heavy U.S. Treasury issuance, margin-linked
          selling in crypto and tech, and a structural lack of breath beneath October’s highs.
        </p>
        <p>
          Despite this, the larger roadmap still points toward a year-end finish above current levels. But with forced selling still in the system and volatility-control flows ready to unwind, the
          path remains uneven — and patience, not aggression, continues to be rewarded.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Liquidity Strains and the Forced Seller Era</p>
              <p>
                Liquidity, not fundamentals, dominated price action. The report highlights that large U.S. Treasury issuance — particularly ahead of Dec 2 — continues to pressure risk assets. Each
                round of supply has forced marginal buyers to dump high-beta equities, crypto, and even precious metals.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="big Treasury equals equity selling short term"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The <span className="highlightedText">Nasdaq 100</span> fulfilled its classic corrective target, tagging the 20-week moving average and wicking below the 24k zone — the traditional
                bounce level in a wave-4 structure.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="20wma arrival where now"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                But technicals aren’t the only stress point. Breadth was weak into the October top, with euphoric flows into unprofitable tech and gold masking underlying fragility. Vol-control models
                remain primed to sell on any VIX breakout, and <span className="highlightedText">CTA</span> positioning suggests further forced liquidations if indices slip again.
              </p>

              <p>
                The AI narrative also lost momentum. <span className="highlightedText">NVIDIA</span> delivered a beat-and-raise, but the market expected more — and concerns surfaced about circular
                client financing and off-balance-sheet risk reminiscent of 1990s structures. While Jensen Huang reiterated structural tailwinds in accelerated computing and agentic AI, the market was
                unconvinced.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="GS AI circularity"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Seasonality argues for upside, but liquidity argues otherwise. For now, liquidity is winning.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Data Divergence, Global Liquidity, and Fed Vote Math</p>

              <p>The macro landscape is growing more contradictory.</p>

              <p>
                The <span className="highlightedText">Atlanta Fed GDPNow</span> model prints a robust 4.2% for Q3 — far above economist expectations — while the{" "}
                <span className="highlightedText">University of Michigan</span> sentiment index collapses.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="Atl 4.2%"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="GDPnow vs UoM collapse"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Globally, liquidity is stirring. China’s money supply now exceeds that of the U.S. and EU combined, a structural force that remains under-appreciated but will inevitably flow into
                global risk assets.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=" China MS the top"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Japan re-entered centre stage with a massive ¥110B stimulus package under PM Takaichi — targeting AI, semiconductors, and advanced manufacturing. The{" "}
                <span className="highlightedText">Bank of Japan</span> is simultaneously monitoring a USDJPY pivot zone, raising the probability of FX intervention or even a rate hike.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image52}
                    alt="UJ intervention coming soon"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image52)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                But the week’s biggest macro theme was the <span className="highlightedText">FOMC vote math.</span>
              </p>

              <p>Based on member speeches, the PDF maps the December FOMC breakdown as:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>5 against a cut</p>
                </li>
                <li className="themesPointer">
                  <p>5 for a cut</p>
                </li>
                <li className="themesPointer">
                  <p>Powell and Jefferson are uncertain</p>
                </li>
              </ul>
              <p>
                Then <span className="highlightedText">John Williams</span> signalled support for a cut — effectively pushing Powell into the dovish column.
              </p>
              <p>Markets reacted sharply.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="rate odds surge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Yet the probability settled around 63% due to deep uncertainty: a narrow 7-5 vote has not occurred since 1983, and the Fed has no formal tie-breaking process for a 6-6 outcome.</p>
              <p>
                Bond volatility (MOVE) eased while <span className="highlightedText">VIX</span> stayed elevated — a peculiar split that reflects liquidity stress without credit panic.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt="rate odds surge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="1D vix"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Credit concerns resurfaced around <span className="highlightedText">Oracle,</span> while the Blue Owl financing withdrawal highlighted tightening conditions beneath the surface.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="credit only worried about Oracle so far"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="Blue Owl credit withdrawn"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Flows into defensive sectors — particularly Healthcare — underscore rising macro caution.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="Healthcare wins again"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr className="divisionLine" />
            <div className="subHeader">
              <div className="contentDivWrapper flexDiv">
                <div className="contentDiv listOfRecap">
                  <p className="highlightedBoldText">Technical & Sentiment Breakdown: Fragile Setups and Rotational Stress</p>
                  <p>
                    Markets remain choppy and indecisive. Intraday rallies continue to fail as volatility-control models sell into strength and liquidity remains thin. Hedge funds continue rotating
                    defensively, while retail and long-only investors persist in buying dips — but the forced-selling dynamic still dominates short-term flows.
                  </p>

                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image34}
                        alt="BOA sentiment flow"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image34)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    Momentum stalled sharply, posting one of the weakest weeks of the year. Breadth remains narrow, systematic selling remains active, and the unwind of crowded positions continues to
                    pressure the tape.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image32}
                        alt="momentum fell off a cliff"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image32)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    Crypto flows show whales offloading into institutional hands — a late-stage stress signature consistent with forced deleveraging, but one that also sets the stage for a potential
                    counter-trend bounce as positioning resets.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image58}
                        alt="BTC sentiment"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image58)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Liquidity Squeeze, AI Stress, and a Chaotic Reversal</p>
              <p>
                Markets opened the week under sustained liquidity pressure — driven by Treasury issuance, funding stress, and forced selling across high-beta tech and crypto — but stabilised into
                Friday as seasonal flows began to reappear and Fed vote-math clarified slightly.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Massive Treasury issuance weighed on equities and crypto as cash was pulled toward government paper. Bond markets kept volatility contained even as equity markets absorbed
                    forced liquidations.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">AI & Tech: </span>
                    <br></br>NVIDIA’s beat-and-raise failed to generate upside as circular financing concerns resurfaced. AI enthusiasm faded into broad tech weakness, with semiconductors and
                    hyperscalers hit hardest.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image16}
                        alt="hyperscalers angst"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image16)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Gold and silver consolidated as margin-related selling hit precious metals alongside the broader risk-off pressure.
                  </p>
                </li>

                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image53}
                      alt=" Q3 earnings BOOM"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image53)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt="commodities still cheap"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image54}
                      alt="where are the gold bugs?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image54)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br></br>Midweek selling — triggered by the linkage between leveraged AI trades and crypto — produced a heavy flush, but underlying accumulation continued at lower levels.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt="BTC sharpe ratios"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Crude drifted lower as weak demand indicators and geopolitical de-escalation headlines capped upside attempts.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image88}
                    alt="btc slump leads stocks lower"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image88)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Data Barrage Meets a Fragile Tape</p>
              <p>
                A holiday-shortened U.S. week still brings a dense macro cluster — especially Wednesday’s data barrage — while Fed officials extend their blackout, leaving markets without verbal
                guidance during a fragile period.
              </p>
              <p className="highlightedText">Monday, Nov 24</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Japan: Labour Day (Holiday)</p>
                </li>
                <li className="themesPointer">
                  <p>Germany: Ifo Expectations, Assessment & Climate</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Chicago Fed National Activity Index</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Bill auctions, 2Y auction</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Nov 25</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Germany: GDP</p>
                </li>
                <li className="themesPointer">
                  <p>Spain: PPI</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Retail Sales (rescheduled), PPI, Redbook, House Price Index, CB Consumer Confidence, Pending Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: API Crude Data</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: 52-week auction, 5Y auction</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Nov 26</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    A macro storm: <br></br>
                    <span>
                      - Core Durable Goods <br></br>- Core PCE (Q3) <br></br>- Q3 GDP + Price Index + Sales
                      <br></br>- Trade Balance
                      <br></br>- New Home Sales
                      <br></br>- Chicago PMI <br></br>- Beige Book
                      <br></br>{" "}
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p> U.S. 4W, 8W, and 7Y auctions</p>
                </li>{" "}
              </ul>

              <p className="highlightedText">Thursday, Nov 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S.: Thanksgiving (Holiday)</p>
                </li>
                <li className="themesPointer">
                  <p>Global data: Eurozone sentiment, NZ retail sales, Italian indicators</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Nov 28</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Japan: Tokyo CPI, Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>Germany: CPI</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone: Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Canada: GDP</p>
                </li>
                <li className="themesPointer">
                  <p>U.S.: Chicago PMI</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: A Wave-4 Reset with Melt-Up Potential — If Liquidity Behaves</p>
              <p>
                The market’s foundation remains fragile. Liquidity strain, Treasury supply, and forced selling continue to distort short-term behaviour — yet the broader structural roadmap remains
                intact: a wave-4 reset, followed by a Q1 push and a major Q3 2026 high.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>A counter-trend rally remains likely if Thursday’s lows hold. A break below them risks delaying the Santa rally and extending the wave-4 chop.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Momentum paused as metals absorbed margin-linked selling, but structurally they remain bullish — especially if risk
                    assets see another wave of volatility.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Institutional absorption signals the bottoming process is advancing, despite elevated volatility and forced liquidation
                    pockets.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>The December cut leans likely, but the unprecedented vote split means volatility will be dictated by how narrow the vote
                    is — not just the outcome.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image42}
                    alt="what a difference a day makes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image42)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt="where are the gold bugs?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image60}
                    alt="BTC adption curve still positive"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image60)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">Trade the liquidity, not the narrative. The melt-up case lives — but only if the market survives wave-4 without a deeper liquidity accident.</span>
              </p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1ErmdrPV9YI0Rev8sg_YQ9wNYy-vCVcOruyZyQ_ID1nc/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog44;
